import * as types from "../types";

const initialState = {
  loading: false,
  realtime: null,
  requestDevice: null,
  error: null,
};

export default function fetchRealtimeReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_REALTIME_REQUEST:
      return {
        ...state,
        loading: true,
        requestDevice: action.payload.requestDevice,
      };

    case types.FETCH_REALTIME_SUCCESS:
      return {
        ...state,
        loading: false,
        realtime: action.payload.realtime,
      };

    case types.FETCH_REALTIME_FAILURE:
      return {
        ...state,
        loading: false,
        realtime: null,
        requestDevice: null,
        error: action.payload.error,
      };

    default:
      return state;
  }
}
